import { openDB } from 'idb';

const DB_NAME = 'sites-db';
const DB_VERSION = 2;
const SITES_STORE = 'sites';
const METADATA_STORE = 'metadata';

export async function getSitesDb() {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(SITES_STORE)) {
        db.createObjectStore(SITES_STORE, { keyPath: 'id' });
      }
      if (!db.objectStoreNames.contains(METADATA_STORE)) {
        db.createObjectStore(METADATA_STORE);
      }
    },
  });
}

// store full API site objects (or adapt if you want summaries)
export async function bulkPutSites(sites) {
  if (!sites || sites.length === 0) return;

  const db = await getSitesDb();
  const tx = db.transaction(SITES_STORE, 'readwrite');
  const store = tx.objectStore(SITES_STORE);

  await Promise.all([
    ...sites.map(site => store.put(site)),
    tx.done
  ]);

  console.log('[IndexedDB] bulkPutSites done');
}

export async function getLastUpdated() {
  const db = await getSitesDb();
  return db.get(METADATA_STORE, 'lastUpdated');
}

export async function setLastUpdated(lastUpdated) {
  const db = await getSitesDb();
  return db.put(METADATA_STORE, lastUpdated, 'lastUpdated');
}

export async function getSchemaVersion() {
  const db = await getSitesDb();
  return db.get(METADATA_STORE, 'schemaVersion');
}

export async function setSchemaVersion(schemaVersion) {
  const db = await getSitesDb();
  return db.put(METADATA_STORE, schemaVersion, 'schemaVersion');
}

export async function getAllSites() {
  const db = await getSitesDb();
  return db.getAll(SITES_STORE);
}

export async function clearSites() {
  const db = await getSitesDb();
  const tx = db.transaction([SITES_STORE, METADATA_STORE], 'readwrite');
  await tx.objectStore(SITES_STORE).clear();
  await tx.objectStore(METADATA_STORE).clear();
  await tx.done;
  console.log('[IndexedDB] Stores cleared');
}
